import { ROUTE_PERMISSION } from '../../config/permission.config.js'

export default [
  { path: '', redirect: 'overview' },
  {
    path: 'overview',
    name: 'AdminOverview',
    component: () => import('../../views/admin/OverviewPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Yhteenveto - Vuokranet',
    },
  },
  {
    path: 'laukaisuloki',
    name: 'AdminTriggerFireLog',
    component: () => import('../../views/admin/TriggerFireLogsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Laukaisuloki - Vuokranet',
    },
  },
  {
    path: 'asetukset',
    name: 'AdminSettings',
    component: () => import('../../views/admin/EmailSettingsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Sähköposti-ilmoitukset - Vuokranet',
    },
  },
  {
    path: 'kayttajat/uusi',
    name: 'AdminUserCreate',
    component: () => import('../../views/admin/AdminUserCreatePage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Uusi käyttäjä - Vuokranet',
    },
  },
  {
    path: 'kayttajat/:id',
    name: 'AdminUserEdit',
    component: () => import('../../views/admin/AdminUserCreatePage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Muokkaa käyttäjää - Vuokranet',
    },
  },
  {
    path: 'kayttajat',
    name: 'AdminUsers',
    component: () => import('../../views/admin/AdminUsersPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Kaikki käyttäjät - Vuokranet',
    },
  },
  {
    path: 'ryhmat/uusi',
    name: 'AdminGroupCreate',
    component: () => import('../../views/admin/AdminGroupCreatePage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Uusi ryhmä - Vuokranet',
    },
  },
  {
    path: 'ryhmat',
    name: 'AdminGroups',
    component: () => import('../../views/admin/AdminGroupsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Kaikki ryhmät - Vuokranet',
    },
  },
  {
    path: 'tilit/uusi',
    name: 'AdminAccountCreate',
    component: () => import('../../views/admin/AdminAccountCreatePage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Uusi tili - Vuokranet',
    },
  },
  {
    path: 'tilit',
    name: 'AdminAccounts',
    component: () => import('../../views/admin/AdminAccountsPage.vue'),
    meta: {
      requiresAuth: true,
      permission: ROUTE_PERMISSION.ADMIN_DASHBOARD,
      layoutRoot: true,
      title: 'Kaikki tilit - Vuokranet',
    },
  },
]
